import { render, staticRenderFns } from "./joinList.vue?vue&type=template&id=eec8beca&scoped=true&"
import script from "./joinList.vue?vue&type=script&lang=js&"
export * from "./joinList.vue?vue&type=script&lang=js&"
import style0 from "./joinList.vue?vue&type=style&index=0&id=eec8beca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec8beca",
  null
  
)

export default component.exports